var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.16,
    height: 21.09,
    viewBox: "0 0 15.16 21.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-explore"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,10.4h-.2a4.7,4.7,0,1,1,.2,0ZM8.3,5.7A3.24,3.24,0,0,0,11.5,9h.3a3.3,3.3,0,0,0-.1-6.6A3.35,3.35,0,0,0,8.3,5.7Z",
    transform: "translate(-4.8 -1)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,18.9a3.73,3.73,0,0,1-1.9-3.2,4,4,0,0,1,1.9-3.2,9.57,9.57,0,0,1,9.8,0,.65.65,0,1,1-.7,1.1,8.22,8.22,0,0,0-8.3,0,2.48,2.48,0,0,0-1.3,2.1,2.72,2.72,0,0,0,1.3,2.1,8,8,0,0,0,4.2,1.1.7.7,0,1,1,0,1.4A8.91,8.91,0,0,1,6.7,18.9Z",
    transform: "translate(-4.8 -1)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_25",
    "data-name": "Capa 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,17.7a3.5,3.5,0,1,1,3.4,3.6A3.54,3.54,0,0,1,12.4,17.7Zm.5,0a3.15,3.15,0,0,0,2.9,3.1,3.08,3.08,0,0,0,3.1-2.9A3.15,3.15,0,0,0,16,14.8,3.08,3.08,0,0,0,12.9,17.7Z",
    transform: "translate(-4.8 -1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,21.6l-.7-.7a.28.28,0,0,1,.4-.4l.7.7a.3.3,0,0,1,0,.4c-.1,0-.1.1-.2.1S19.2,21.7,19.1,21.6Z",
    transform: "translate(-4.8 -1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.77
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-4.8 -1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-4.8 -1)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExplore);
export default __webpack_public_path__ + "static/media/user-explore.6aab3a9cb36a4a749b1b8dab098030f7.svg";
export { ForwardRef as ReactComponent };